module.exports = __webpack_public_path__ + "static/media/bedroom.591fb35c.jpg";